const actions = {

  // DO_GET_PROPERTY
  DO_GET_PROPERTY: 'DO_GET_PROPERTY',
  doGetProperty: hash => ({
    type: actions.DO_GET_PROPERTY,
    payload: hash
  }),
  DO_GET_PROPERTY_SUCCESS: 'DO_GET_PROPERTY_SUCCESS',
  doGetPropertySuccess: hash => ({
    type: actions.DO_GET_PROPERTY_SUCCESS,
    payload: hash
  }),
  DO_GET_PROPERTY_FAILED: 'DO_GET_PROPERTY_FAILED',
  doGetPropertyFailed: hash => ({
    type: actions.DO_GET_PROPERTY_FAILED,
    payload: hash
  }),

  // DO_GET_INVITED_TENANTS
  DO_GET_INVITED_TENANTS: 'DO_GET_INVITED_TENANTS',
  doGetInvitedTenants: () => ({
    type: actions.DO_GET_INVITED_TENANTS
  }),
  DO_GET_INVITED_TENANTS_SUCCESS: 'DO_GET_INVITED_TENANTS_SUCCESS',
  doGetInvitedTenantsSuccess: response => ({
    type: actions.DO_GET_INVITED_TENANTS_SUCCESS,
    payload: response
  }),
  DO_GET_INVITED_TENANTS_FAILED: 'DO_GET_INVITED_TENANTS_FAILED',
  doGetInvitedTenantsFailed: response => ({
    type: actions.DO_GET_INVITED_TENANTS_FAILED,
    payload: response
  }),

  // DO_CREATE_AST
  DO_CREATE_AST: 'DO_CREATE_AST',
  doCreateAst: payload => ({
    type: actions.DO_CREATE_AST,
    payload
  }),
  DO_CREATE_AST_SUCCESS: 'DO_CREATE_AST_SUCCESS',
  doCreateAstSuccess: response => ({
    type: actions.DO_CREATE_AST_SUCCESS,
    payload: response
  }),
  DO_CREATE_AST_FAILED: 'DO_CREATE_AST_FAILED',
  doCreateAstFailed: response => ({
    type: actions.DO_CREATE_AST_FAILED,
    payload: response
  }),

  // DO_GET_AST
  DO_GET_AST: 'DO_GET_AST',
  doGetAst: (hash, includeExtraData) => ({
    type: actions.DO_GET_AST,
    payload: hash,
    includeExtraData: !!includeExtraData || false
  }),
  DO_GET_AST_SUCCESS: 'DO_GET_AST_SUCCESS',
  doGetAstSuccess: response => ({
    type: actions.DO_GET_AST_SUCCESS,
    payload: response
  }),
  DO_GET_AST_FAILED: 'DO_GET_AST_FAILED',
  doGetAstFailed: response => ({
    type: actions.DO_GET_AST_FAILED,
    payload: response
  }),

  // DO_LIST_TA_AGREEMENTS
  DO_LIST_TA_AGREEMENTS: 'DO_LIST_TA_AGREEMENTS',
  doListTaAgreements: () => ({
    type: actions.DO_LIST_TA_AGREEMENTS
  }),
  DO_LIST_TA_AGREEMENTS_SUCCESS: 'DO_LIST_TA_AGREEMENTS_SUCCESS',
  doListTaAgreementsSuccess: response => ({
    type: actions.DO_LIST_TA_AGREEMENTS_SUCCESS,
    payload: response
  }),
  DO_LIST_TA_AGREEMENTS_FAILED: 'DO_LIST_TA_AGREEMENTS_FAILED',
  doListTaAgreementsFailed: response => ({
    type: actions.DO_LIST_TA_AGREEMENTS_FAILED,
    payload: response
  }),

  // DO_UPDATE_AST
  DO_UPDATE_AST: 'DO_UPDATE_AST',
  doUpdateAst: (hash, payload) => ({
    type: actions.DO_UPDATE_AST,
    hash,
    payload
  }),
  DO_UPDATE_AST_SUCCESS: 'DO_UPDATE_AST_SUCCESS',
  doUpdateAstSuccess: response => ({
    type: actions.DO_UPDATE_AST_SUCCESS,
    payload: response
  }),
  DO_UPDATE_AST_FAILED: 'DO_UPDATE_AST_FAILED',
  doUpdateAstFailed: response => ({
    type: actions.DO_UPDATE_AST_FAILED,
    payload: response
  }),

  // DO_DELETE_AST
  DO_DELETE_AST: 'DO_DELETE_AST',
  doDeleteAst: hash => ({
    type: actions.DO_DELETE_AST,
    payload: hash
  }),
  DO_DELETE_AST_SUCCESS: 'DO_DELETE_AST_SUCCESS',
  doDeleteAstSuccess: response => ({
    type: actions.DO_DELETE_AST_SUCCESS,
    payload: response
  }),
  DO_DELETE_AST_FAILED: 'DO_DELETE_AST_FAILED',
  doDeleteAstFailed: response => ({
    type: actions.DO_DELETE_AST_FAILED,
    payload: response
  }),

  // DO_SIGN_AST
  DO_SIGN_AST: 'DO_SIGN_AST',
  doSignAst: hash => ({
    type: actions.DO_SIGN_AST,
    payload: hash
  }),
  DO_SIGN_AST_SUCCESS: 'DO_SIGN_AST_SUCCESS',
  doSignAstSuccess: response => ({
    type: actions.DO_SIGN_AST_SUCCESS,
    payload: response
  }),
  DO_SIGN_AST_FAILED: 'DO_SIGN_AST_FAILED',
  doSignAstFailed: response => ({
    type: actions.DO_SIGN_AST_FAILED,
    payload: response
  }),

  // DO_UPDATE_TA_DATA
  DO_UPDATE_TA_DATA: 'DO_UPDATE_TA_DATA',
  doUpdateTaData: data => ({
    type: actions.DO_UPDATE_TA_DATA,
    payload: data
  }),
  DO_CLEAR_TA_DATA: 'DO_CLEAR_TA_DATA',
  doClearTaData: () => ({
    type: actions.DO_CLEAR_TA_DATA
  })
}

export default actions;



// WEBPACK FOOTER //
// ./src/redux/propertiesTenancyAgreements/actions.js